import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { App } from "./App";
import { oidcConfig } from "./lib/config";
// Self-hosted brand faces (latin subset, only the weights styles.css uses), so
// staff browsers never contact Google Fonts. Vite fingerprints the woff2 files.
import "@fontsource/jost/latin-400.css";
import "@fontsource/jost/latin-500.css";
import "@fontsource/jost/latin-600.css";
import "@fontsource/cormorant-garamond/latin-400.css";
import "@fontsource/ibm-plex-mono/latin-400.css";
import "./styles.css";

/** Strip the OIDC query params after sign-in so a refresh does not replay the
 *  authorization code, which Cognito rejects the second time. */
function onSigninCallback(): void {
  window.history.replaceState({}, document.title, window.location.pathname);
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig} onSigninCallback={onSigninCallback}>
      <App />
    </AuthProvider>
  </React.StrictMode>,
);
